import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

const ParallaxElement = ({
  children,
  speed = 0.5,
  direction = "up",
  className = "",
  ...props
}) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    // Define parallax directions
    const directions = {
      up: { y: `-${100 * speed}%` },
      down: { y: `${100 * speed}%` },
      left: { x: `-${100 * speed}%` },
      right: { x: `${100 * speed}%` },
      scale: { scale: 1 + speed * 0.5 },
    };

    const transform = directions[direction] || directions.up;

    // Create parallax animation
    gsap.to(element, {
      ...transform,
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });

    // Cleanup
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => {
        if (trigger.trigger === element) {
          trigger.kill();
        }
      });
    };
  }, [speed, direction]);

  return (
    <div ref={elementRef} className={className} {...props}>
      {children}
    </div>
  );
};

export default ParallaxElement;
